import { batch } from 'react-redux';
import { EmeraldError } from 'src/common/api/emerald-error';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { TenderType } from 'src/common/enumerations/tender-type';
import {
  EwicNoWicAllowedItemInBasketException,
  TenderAmountExceededEligibilityAmount,
  TendersOrderViolation,
  TooManyUniqueWicItems,
  WicMixedTransactionRestriction,
  WicTenderRestriction,
} from 'src/common/helpers/error-code';
import { store } from 'src/common/redux/configure-store';
import { TenderMenuActions } from 'src/common/redux/reducers/tender-menu-reducer';
import { TenderingActions } from 'src/common/redux/reducers/tendering-reducer';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { getEwicSettings } from './services/get-ewic-settings';
import { showEwicError } from './show-ewic-error';
import { showNotification } from './show-notification';

export const showEwicErrorModal = (err: EmeraldError): Promise<void> => {
  // TODO: promise executor function should not be async
  // eslint-disable-next-line
  return new Promise<void>(async (resolve, reject) => {
    if (err instanceof EmeraldError) {
      switch (err.code) {
        case TendersOrderViolation: {
          await showEwicError(
            'EwicMustBeFirstTitle',
            'EwicMustBeFirstMessage',
            'Switch Tender',
            'Cancel',
          ).catch(() => {
            store.dispatch(TenderingActions.setState({ tabValue: 0 }));
          });
          resolve();
          break;
        }
        case WicTenderRestriction: {
          await showNotification(
            'ActionProhibited',
            err.message ?? 'EwicNoEligibleItemsExceptionMessage',
            EmeraldDialogTypes.Info,
          );
          store.dispatch(TenderingActions.setState({ tabValue: 0 }));
          resolve();
          break;
        }
        case EwicNoWicAllowedItemInBasketException: {
          await showNotification(
            'EwicNoEligibleItemsExceptionTitle',
            'EwicNoEligibleItemsExceptionMessage',
          );
          resolve();
          break;
        }
        case TooManyUniqueWicItems: {
          await handleTooManyEwicItemsMessage();
          resolve();
          break;
        }
        case WicMixedTransactionRestriction: {
          await showNotification(
            'ActionProhibited',
            'WicMixedTransactionRestriction',
            EmeraldDialogTypes.Info,
          );
          store.dispatch(TenderingActions.setState({ tabValue: 0 }));
          resolve();
          break;
        }
        case TenderAmountExceededEligibilityAmount: {
          await showNotification(
            'EwicAlternateTenderNotificationTitle',
            'NoEligibleWicItemsMessage',
            EmeraldDialogTypes.Info,
          );
          store.dispatch(TenderingActions.setState({ tabValue: 0 }));
          resolve();
          break;
        }
      }
    }
    reject(err);
  });
};

const handleTooManyEwicItemsMessage = async (): Promise<void> => {
  const { showEwicQuantityErrorMessage } = getCurrentXLRConfig();
  if (showEwicQuantityErrorMessage) {
    const ewicSetting = await getEwicSettings();
    await showNotification(
      'EwicTooManyUniqueWicItemsTitle',
      'EwicExceededSpecificNumberMessage',
      EmeraldDialogTypes.Info,
      undefined,
      {
        arg: ewicSetting.onlinePsRecordLimit.toString(),
      },
    );
  } else {
    await showNotification(
      'EwicTooManyUniqueWicItemsTitle',
      'EwicExceededMaximumNumberMessage',
      EmeraldDialogTypes.Info,
    );
  }

  const unPaidPreTender = store.getState().tenderMenu.unPaidPreTender;
  batch((): void => {
    if (unPaidPreTender && unPaidPreTender.tender?.tenderType === TenderType.Ewic) {
      store.dispatch(TenderMenuActions.clearUnPaidPreTender());
    }
    store.dispatch(TenderingActions.setState({ tabValue: 0 }));
  });
};
